import Api from './api';
import * as config from './config';
import * as errors from './error';
import * as statusCodes from './api/v2/status-codes';

export default Api;
export { config, errors, statusCodes };
